import Styled from 'styled-components/macro';

export const DetailsWrapper = Styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-top: 30px;
    margin-bottom: 100px;
`;
